import { selectedProcess } from '@/consts/auth';
import { loginType } from '@/consts/login';
import { SelectedProcess } from '@/types/api/authApi';
import { LoginType } from '@/types/login';

interface ResolveLoginTelParams {
  selectedProcess: SelectedProcess;
  phoneNumber: string;
  previousPhoneNumber?: string;
  storedLoginTel: string | null;
}

export const clearLoginTel = (
  storage: Pick<Storage, 'removeItem'> = window.localStorage,
): void => {
  storage.removeItem('loginTel');
};

export const getLoginTelForType = (
  type: string | null | undefined,
  storage: Pick<Storage, 'getItem'> = window.localStorage,
): string => {
  return type === loginType.TELEPHONE ? storage.getItem('loginTel') || '' : '';
};

export const getValidLoginType = (type: string | null | undefined): LoginType =>
  Object.values(loginType).includes(type as LoginType)
    ? (type as LoginType)
    : loginType.NONE;

interface LoginContext {
  loginType?: LoginType;
  tel?: string;
}

export const persistLoginContext = (
  context: LoginContext,
  storage: Pick<Storage, 'setItem'> = window.localStorage,
): void => {
  if (context.loginType) {
    storage.setItem('loginType', context.loginType);
  }
  if (context.loginType === loginType.TELEPHONE && context.tel) {
    storage.setItem('loginTel', context.tel);
  }
};

export const resolveLoginTelAfterPinSuccess = ({
  selectedProcess: process,
  phoneNumber,
  previousPhoneNumber,
  storedLoginTel,
}: ResolveLoginTelParams): string | null => {
  if (process === selectedProcess.login) return phoneNumber;

  const isChangingLoginTel =
    process === selectedProcess.change &&
    storedLoginTel !== null &&
    storedLoginTel === previousPhoneNumber;

  return isChangingLoginTel ? phoneNumber : storedLoginTel;
};
